import APIManager from './APIManager';
import ACHIEVEMENTS from '../achievements';

let defaultState = { musicOn: true, soundsOn: true, barriersDestroyed: 0 };

let DataManager = function () {
  if (DataManager.prototype._singletonInstance) {
    return DataManager.prototype._singletonInstance;
  }

  DataManager.prototype._singletonInstance = this;

  this.apiManager = new APIManager();
  this.debug = this.apiManager.sdk.debug;
  this.achievements = _.cloneDeep(ACHIEVEMENTS);
  // console.log('local achievements', this.achievements);
  this.debug('local achievements', this.achievements);

  // default score object, these values are saved using the sdk
  this.score = { active: 0, high: 0 };

  // default state object, this gets saved to the users account via the sdk api
  this.state = defaultState;

  // session memory, these values are not saved across sessions or by the sdk
  this.session = { specialsCompleted: 0, lastFloor: 0 };

  // attempt to retrieve high score
  try{
    const data = localStorage.getItem('forevertower_data');
    if(data){
      var state = JSON.parse(data);
      this.score.high = _.isNumber(state.score) === false ? 0 : state.score;
    }
  }
  catch(e){
    console.warn("Unable to get data, error: ", e);
  }
};

DataManager.prototype.checkHighScore = function () {
  // console.log('DataManager.checkHighScore');
  this.debug('DataManager.checkHighScore');
  if (this.score.active > this.score.high) {
    this.score.high = this.score.active;

    try{
      localStorage.setItem('forevertower_data', JSON.stringify({ score: this.score.high }));
    }
    catch(e){
      console.warn("Unable to save data, error: ", e);
    }
  }
};

DataManager.prototype.addPoints = function (points) {
  this.score.active += points;
  // if (this.score.active >= this.achievements.BeeAggressive.hardCodeRequired) {
  //   this.unlockAchievement(this.achievements.BeeAggressive);
  // }
};

DataManager.prototype.setScore = function (points) {
  this.score.active = points;
};

DataManager.prototype.getScore = function () {
  return this.score.active;
};

DataManager.prototype.getHighScore = function () {
  return this.score.high;
};

DataManager.prototype.clearActiveScore = function () {
  this.score.active = 0;
};

DataManager.prototype.setItem = function (key, value) {
  // console.log('DataManager.setItem', key, value);
  this.state[key] = value;
};

DataManager.prototype.getItem = function (key) {
  // console.log('DataManager.getItem', key);
  return this.state[key];
};

DataManager.prototype.setSessionItem = function (key, value) {
  // console.log('DataManager.setSessionItem', key, value);
  this.session[key] = value;
};

DataManager.prototype.getSessionItem = function (key) {
  // console.log('DataManager.getSessionItem', key);
  return this.session[key];
};

DataManager.prototype.addAchievementProgress = function (local, value) {
};

DataManager.prototype.getAchievementProgress = function (local, cb) {
};

DataManager.prototype.unlockAchievement = function (local) {
};

export default DataManager;
